var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.videoSrc)?_c('video-player',{attrs:{"src":_vm.videoSrc}}):_vm._e(),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }